import React from "react";
import LookupAdmin, { ColorSwatch, ActiveChip } from "../../components/LookupAdmin";

const slugify = (s) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const config = {
  title: "Tags de Cliente",
  subtitle: "Marcadores livres para segmentar a base — a cor cadastrada aqui é a que aparece nas telas de cliente e atendimento.",
  endpoint: "/client-tags",
  labelField: "name",
  fields: [
    { name: "name", label: "Nome", required: true, span: 4 },
    { name: "slug", label: "Slug", span: 4, placeholder: "auto" },
    { name: "color", label: "Cor", type: "color", defaultValue: "#6c757d" },
    { name: "description", label: "Descrição", span: 12 },
    { name: "active", label: "Ativo", type: "boolean", defaultValue: true },
  ],
  columns: [
    {
      key: "name",
      label: "Tag",
      render: (t) => (
        <>
          <ColorSwatch color={t.color} />
          {t.name}
        </>
      ),
    },
    { key: "slug", label: "Slug" },
    { key: "description", label: "Descrição" },
    {
      key: "clientCount",
      label: "Clientes",
      render: (t) => t.clientCount ?? 0,
    },
    { key: "active", label: "Status", render: (t) => <ActiveChip active={t.active} /> },
  ],
};

// Auto-fill slug if empty: wrap LookupAdmin? Keep it simple — backend can also do it.
// We just present the form as-is; if slug omitted, server can default.
export { slugify };

const ClientTags = () => <LookupAdmin config={config} />;

export default ClientTags;
